module.exports = __webpack_public_path__ + "static/media/todos.aa2bb775.png";